import axios from 'axios';

const studentskill = {
    state: {  
		studentskills : []
	},	
	mutations: {		
		studentskills_success(state, payload){			
			state.studentskills = payload	
		}	
	},
	actions: {
        getstudentpsycomotor(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Studentpsycomotor/Getstudentpsycomotor', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {						
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},			
		getstudentpsycomotorbyid(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Studentpsycomotor/Getstudentpsycomotorbyid', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},						
		studentpsycomotorregistration(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Studentpsycomotor/Registerstudentpsycomotor', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
        },        
	}
}

export default studentskill